import { Permission } from '@blackbox-vision/ra-rbac';

export let canActivate = (
  permissions: Permission[] | any,
  resource: string,
  action: string,
  field?: string
) => {
  // Your can activate logic
  return true;
};
